/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deleteaccountwarning2Inputs */

const en_deleteaccountwarning2 = /** @type {(inputs: Deleteaccountwarning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete your account? This will permanently delete all your data.`)
};

const de_deleteaccountwarning2 = /** @type {(inputs: Deleteaccountwarning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willst du dein Konto wirklich löschen? Dabei werden alle deine Daten endgültig gelöscht.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete your account? This will permanently delete all your data." |
*
* @param {Deleteaccountwarning2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const deleteaccountwarning2 = /** @type {((inputs?: Deleteaccountwarning2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deleteaccountwarning2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deleteaccountwarning2(inputs)
	return de_deleteaccountwarning2(inputs)
});
export { deleteaccountwarning2 as "deleteAccountWarning" }